import { IonChip as IonicIonChip } from '@ionic/react'
import styled from 'styled-components'

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
`

export const IonChip = styled(IonicIonChip)`
  margin: 0;
  position: absolute;
  top: 0;
  left: 16px;
  right: 16px;
`
